export default "__VITE_ASSET__CbIN4Jpj__"